import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectFilters = ({ 
  filters, 
  activeFilters, 
  onFilterChange, 
  onClearFilters,
  projectCount 
}) => {
  const handleFilterClick = (category, value) => {
    const currentValues = activeFilters?.[category] || [];
    const newValues = currentValues?.includes(value)
      ? currentValues?.filter(v => v !== value)
      : [...currentValues, value];
    
    onFilterChange(category, newValues);
  };

  const isFilterActive = (category, value) => {
    return activeFilters?.[category]?.includes(value) || false;
  };

  const hasActiveFilters = Object.values(activeFilters)?.some(values => values?.length > 0);

  return (
    <div className="bg-card rounded-xl border border-border p-6 brand-shadow">
      {/* Filter Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="Filter" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-brand-subheading text-foreground">
              Filter Projects
            </h3>
            <p className="text-sm text-text-secondary">
              {projectCount} projects found
            </p>
          </div>
        </div>
        
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
            className="text-text-secondary hover:text-primary"
          >
            Clear All
          </Button>
        )}
      </div>
      {/* Filter Categories */}
      <div className="space-y-6">
        {Object.entries(filters)?.map(([category, options]) => (
          <div key={category}>
            <h4 className="text-sm font-brand-medium text-foreground mb-3 capitalize">
              {category?.replace(/([A-Z])/g, ' $1')?.trim()}
            </h4>
            <div className="flex flex-wrap gap-2">
              {options?.map((option) => (
                <button
                  key={option}
                  onClick={() => handleFilterClick(category, option)}
                  className={`px-3 py-2 rounded-lg text-sm font-brand-medium transition-all duration-200 ${
                    isFilterActive(category, option)
                      ? 'bg-primary text-primary-foreground border border-primary'
                      : 'bg-muted text-text-secondary hover:bg-primary/10 hover:text-primary border border-transparent'
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      {/* Active Filters Summary */}
      {hasActiveFilters && (
        <div className="mt-6 pt-6 border-t border-border">
          <h4 className="text-sm font-brand-medium text-foreground mb-3">
            Active Filters
          </h4>
          <div className="flex flex-wrap gap-2">
            {Object.entries(activeFilters)?.map(([category, values]) =>
              values?.map((value) => (
                <div
                  key={`${category}-${value}`}
                  className="flex items-center space-x-2 px-3 py-1 bg-primary/10 text-primary text-xs font-brand-medium rounded-full border border-primary/20"
                >
                  <span>{value}</span>
                  <button
                    onClick={() => handleFilterClick(category, value)}
                    className="hover:bg-primary/20 rounded-full p-0.5 transition-colors"
                    aria-label={`Remove ${value} filter`}
                  >
                    <Icon name="X" size={12} />
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectFilters;